let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hbhLQ")).then(() => parcelRequire('5iVev'));